module.exports = __webpack_public_path__ + "img/IMG_5904.3825840b.jpg";